import { render, staticRenderFns } from "./r-flash-ad-config-table.vue?vue&type=template&id=6ab115ef"
import script from "./r-flash-ad-config-table.vue?vue&type=script&lang=js"
export * from "./r-flash-ad-config-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab115ef')) {
      api.createRecord('6ab115ef', component.options)
    } else {
      api.reload('6ab115ef', component.options)
    }
    module.hot.accept("./r-flash-ad-config-table.vue?vue&type=template&id=6ab115ef", function () {
      api.rerender('6ab115ef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-flash-ad/r-flash-ad-config-table.vue"
export default component.exports